// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AdminPage.module.css */
.AdminPage_adminWrapper__3ft0q {
  margin-top: 60px; /* Высота основного меню */
}

.AdminPage_adminNavbar__AE1Cu {
  position: fixed;
  top: 60px; /* Располагаем ниже основного меню */
  left: 0;
  right: 0;
  background: #2c3e50;
  z-index: 998;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.AdminPage_navContainer__hsnMJ {
  max-width: 100vw;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  overflow-x: auto; /* Оставляем скролл только тут! */
}

.AdminPage_navBrand__klufI {
  color: #ecf0f1;
  font-weight: bold;
  padding: 1rem;
  text-decoration: none;
}

.AdminPage_navItems__LNadf {
  display: flex;
  flex-grow: 1;
  position: relative;
  flex-wrap: nowrap;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.AdminPage_navItems__LNadf::-webkit-scrollbar {
  display: none;
}

.AdminPage_navItem__0Q33U {
  position: relative;
  color: #ecf0f1;
  padding: 1rem 1.2rem;      /* Можно уменьшить паддинги */
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  transition: background 0.2s;
  white-space: nowrap;       /* Запретить перенос внутри пункта */
  flex-shrink: 0;            /* Не сжимать пункты */
}

.AdminPage_navItem__0Q33U:hover {
  background: #34495e;
}

.AdminPage_dropdownMenu__7ZOYe {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  min-width: 200px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  border-radius: 4px;
  z-index: 999;
}

.AdminPage_dropdownItem__5Od\\+z {
  display: block;
  padding: 0.75rem 1rem;
  color: #2c3e50;
  text-decoration: none;
  transition: background 0.2s;
}

.AdminPage_dropdownItem__5Od\\+z:hover {
  background: #f8f9fa;
}

.AdminPage_adminContent__cXcJS {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.AdminPage_waitingBadge__uoca0 {
  background: #e74c3c;
  color: white;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: bold;
  margin-left: 0.5rem;
  padding: 0 0.25rem;
}

@media (max-width: 768px) {
  .AdminPage_navContainer__hsnMJ {
    flex-direction: column;
    padding: 0;
  }

  .AdminPage_navItems__LNadf {
    flex-direction: row;
    width: 100%;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .AdminPage_navItems__LNadf::-webkit-scrollbar {
    display: none;
  }

  .AdminPage_navItem__0Q33U {
    justify-content: center;
    min-width: 140px;
    padding: 1rem 0.5rem;
    flex-shrink: 0;
  }

  .AdminPage_dropdownMenu__7ZOYe {
    position: absolute;
    left: 0;
    top: 100%;
    width: max-content;
    min-width: 180px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    z-index: 999;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AdminPage/AdminPage.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA;EACE,eAAe;EACf,SAAS,EAAE,oCAAoC;EAC/C,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB,EAAE,iCAAiC;AACrD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB,OAAO,6BAA6B;EACxD,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB,QAAQ,oCAAoC;EAC/D,cAAc,aAAa,sBAAsB;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,iCAAiC;IACjC,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,qCAAqC;IACrC,YAAY;EACd;AACF","sourcesContent":["/* AdminPage.module.css */\n.adminWrapper {\n  margin-top: 60px; /* Высота основного меню */\n}\n\n.adminNavbar {\n  position: fixed;\n  top: 60px; /* Располагаем ниже основного меню */\n  left: 0;\n  right: 0;\n  background: #2c3e50;\n  z-index: 998;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.navContainer {\n  max-width: 100vw;\n  margin: 0 auto;\n  padding: 0 20px;\n  display: flex;\n  align-items: center;\n  overflow-x: auto; /* Оставляем скролл только тут! */\n}\n\n.navBrand {\n  color: #ecf0f1;\n  font-weight: bold;\n  padding: 1rem;\n  text-decoration: none;\n}\n\n.navItems {\n  display: flex;\n  flex-grow: 1;\n  position: relative;\n  flex-wrap: nowrap;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n.navItems::-webkit-scrollbar {\n  display: none;\n}\n\n.navItem {\n  position: relative;\n  color: #ecf0f1;\n  padding: 1rem 1.2rem;      /* Можно уменьшить паддинги */\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  text-decoration: none;\n  transition: background 0.2s;\n  white-space: nowrap;       /* Запретить перенос внутри пункта */\n  flex-shrink: 0;            /* Не сжимать пункты */\n}\n\n.navItem:hover {\n  background: #34495e;\n}\n\n.dropdownMenu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background: #fff;\n  min-width: 200px;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n  border-radius: 4px;\n  z-index: 999;\n}\n\n.dropdownItem {\n  display: block;\n  padding: 0.75rem 1rem;\n  color: #2c3e50;\n  text-decoration: none;\n  transition: background 0.2s;\n}\n\n.dropdownItem:hover {\n  background: #f8f9fa;\n}\n\n.adminContent {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.waitingBadge {\n  background: #e74c3c;\n  color: white;\n  border-radius: 50%;\n  min-width: 20px;\n  height: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: bold;\n  margin-left: 0.5rem;\n  padding: 0 0.25rem;\n}\n\n@media (max-width: 768px) {\n  .navContainer {\n    flex-direction: column;\n    padding: 0;\n  }\n\n  .navItems {\n    flex-direction: row;\n    width: 100%;\n    flex-wrap: nowrap;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n  }\n  .navItems::-webkit-scrollbar {\n    display: none;\n  }\n\n  .navItem {\n    justify-content: center;\n    min-width: 140px;\n    padding: 1rem 0.5rem;\n    flex-shrink: 0;\n  }\n\n  .dropdownMenu {\n    position: absolute;\n    left: 0;\n    top: 100%;\n    width: max-content;\n    min-width: 180px;\n    box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n    z-index: 999;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adminWrapper": `AdminPage_adminWrapper__3ft0q`,
	"adminNavbar": `AdminPage_adminNavbar__AE1Cu`,
	"navContainer": `AdminPage_navContainer__hsnMJ`,
	"navBrand": `AdminPage_navBrand__klufI`,
	"navItems": `AdminPage_navItems__LNadf`,
	"navItem": `AdminPage_navItem__0Q33U`,
	"dropdownMenu": `AdminPage_dropdownMenu__7ZOYe`,
	"dropdownItem": `AdminPage_dropdownItem__5Od+z`,
	"adminContent": `AdminPage_adminContent__cXcJS`,
	"waitingBadge": `AdminPage_waitingBadge__uoca0`
};
export default ___CSS_LOADER_EXPORT___;
